"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChartSummaryContainer = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgInSelectArrow = require("../svg/interface/SvgInSelectArrow");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".c93e1d76b{display:block}.cdf7b710c{font-size:1rem;font-weight:400;line-height:1.125rem;margin-bottom:.625rem;color:var(--color-flomni-gray-70);max-width:100%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.c3c8f63fa{color:var(--color-flomni-gray-90);padding-top:.875rem;text-align:center;font-size:1rem;font-weight:400;line-height:1.125rem;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;height:3.4375rem;box-sizing:border-box}.c98ef33d7{display:flex;align-items:center}.c6fa00c5d{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;font-size:2rem;font-weight:400;line-height:2.3125rem;color:var(--color-flomni-blue-70);padding-right:.625rem}.cd658036d{flex-shrink:0}.c4c5aa552{display:flex;align-items:center}.c36b050b7{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;font-size:1rem;font-weight:400;line-height:1.125rem}.c298fd071{flex-shrink:0;width:.4375rem;display:inline-flex;margin-left:.375rem}.c5f06f1be .c36b050b7{color:var(--color-flomni-rose-70)}.c5f06f1be .c298fd071{color:var(--color-flomni-rose-70);-webkit-transform:rotate(0);transform:rotate(0)}.c4d7fab57 .c36b050b7{color:var(--color-flomni-green-70)}.c4d7fab57 .c298fd071{color:var(--color-flomni-green-70);-webkit-transform:rotate(180deg);transform:rotate(180deg)}.c0e19a67b .c4c5aa552{visibility:hidden}");
var styles = {
  root: 'c93e1d76b',
  title: 'cdf7b710c',
  message: 'c3c8f63fa',
  content: 'c98ef33d7',
  total: 'c6fa00c5d',
  chart: 'cd658036d',
  difference: 'c4c5aa552',
  ammount: 'c36b050b7',
  icon: 'c298fd071',
  '--view-down': 'c5f06f1be',
  '--view-up': 'c4d7fab57',
  '--view-hidden': 'c0e19a67b'
};

var ChartSummaryContainer = function ChartSummaryContainer(props) {
  var view = props.view,
      title = props.title,
      content = props.content,
      difference = props.difference,
      children = props.children,
      classes = props.classes,
      message = props.message;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, cn.view[view])
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.title
  }, title), message ? /*#__PURE__*/_react.default.createElement("div", {
    className: cn.message
  }, message) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.content
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.total
  }, content), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.chart
  }, children)), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.difference
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.ammount
  }, difference), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.icon
  }, /*#__PURE__*/_react.default.createElement(_SvgInSelectArrow.SvgInSelectArrow, null)))));
};

exports.ChartSummaryContainer = ChartSummaryContainer;
var view = ['up', 'down', 'hidden'];
ChartSummaryContainer.modes = {
  view: view
};
ChartSummaryContainer.propTypes = {
  /* component logic props */
  title: _propTypes.node.isRequired,
  content: _propTypes.node.isRequired,
  difference: _propTypes.node.isRequired,
  children: _propTypes.node.isRequired,
  message: _propTypes.node,

  /* styling modificators */
  view: (0, _propTypes.oneOf)(view),

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
ChartSummaryContainer.defaultProps = {
  view: 'up',
  classes: {},
  message: null
};